import styled, { css } from 'styled-components';

export const LayoutDetailFieldComponent = styled.div.withConfig({
    shouldForwardProp: (prop) => !['hoverable', 'clickableValue'].includes(prop),
})<{
    hoverable?: boolean;
    hoverableValue?: boolean;
    clickableValue?: boolean;
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 50px;
    padding: 5px 8px;
    border-radius: 8px;

    owc-button {
        visibility: hidden;
    }

    > div.content {
        text-wrap: wrap;
    }

    ${({ hoverable }) =>
        hoverable &&
        `
                &:hover {
                    background-color: var(--one-color-blue-100);

                    owc-button {
                        visibility: visible;
                    }
                }
            `}

    owc-typography[element='p'] {
        color: var(--one-color-foreground-base);
    }

    owc-typography[element='span'] {
        padding-left: 4px;
        color: var(--one-color-gray-600);
        line-break: anywhere;
        ${({ clickableValue }) =>
            clickableValue &&
            css`
                color: var(--one-color-blue-600);
                cursor: pointer;
            `}
    }
`;
